import { createAsyncStore } from '@pfg/vue-async';
import types from '@/constants/types';
import { login } from '@/api/login';
import { GetDataBeneficiary } from '@/api/getDataBeneficiary';
import { postCreateBeneficiary } from '@/api/beneficiaries-api';
import { postRecoveryPassword } from '@/api/recoveryPassword-api';
import { validateBeneficiary } from '@/api/validateBeneficiaries-api';
import { verifyCi } from '@/api/verifyCi-api';
import { verifyBeneficiary, getVerifyBeneficiarySendEmail } from '@/api/verifyBeneficiary-api';

const errorHandlers = {
  401: error => error,
  404: error => error,
  409: error => error,
  500: error => error,
};

const actionsData = [
  { actionType: types.async.LOGIN, asyncFn: login, errorHandlers },
  { actionType: types.async.DATA_BENEFICIARY, asyncFn: GetDataBeneficiary, errorHandlers },
  {
    actionType: types.async.POST_CREATE_BENEFICIARY,
    asyncFn: postCreateBeneficiary,
    errorHandlers,
  },
  {
    actionType: types.async.POST_RECOVERY_PASSWORD,
    asyncFn: postRecoveryPassword,
    errorHandlers,
  },
  {
    actionType: types.async.GET_VALIDATE_BENEFICIARY,
    asyncFn: validateBeneficiary,
    errorHandlers,
  },
  {
    actionType: types.async.GET_VERIFY_BENEFICIARY,
    asyncFn: verifyBeneficiary,
    errorHandlers,
  },
  {
    actionType: types.async.GET_VERIFY_CI,
    asyncFn: verifyCi,
    errorHandlers,
  },
  {
    actionType: types.async.GET_VERIFY_BENEFICIARY_SEND_EMAIL,
    asyncFn: getVerifyBeneficiarySendEmail,
    errorHandlers,
  },
];

export default {
  namespaced: false,
  ...createAsyncStore(actionsData),
};
